/* 
/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 * Analytics msgbus event handler
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager, globalEngine } from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function CreateEventConfig()
{
	var event_config =
	{
		"getEvents" : function()
		{
			var events = ModuleManager.getSingleton("event_config");
			if (events.hasOwnProperty('data'))
				return events['data'];
			return events;
		},
		"getProfileNames": function(eventId)
		{
			try { 	return   this.getEvents()[eventId].profileNames; } catch(e) { return null; }
		},
		"getAttributeRules": function(eventId)
		{
			try { return this.getEvents()[eventId].attributeRules; } catch(e) { return null; }
		},
		"getPriority": function(eventId)
		{
			try { return this.getEvents()[eventId].priority; } catch(e) { return 0; }
		},
		"getEventPriority": function(eventId)
		{
			try { return this.getEvents()[eventId].attributeRules['priority']['meta']; } catch(e) { return null; }
		},
		"getDataSetNames": function(eventId)
		{
			try { return this.getEvents()[eventId].datasets; } catch(e) { return []; }
		},
		// used for automation
		"_setEvent" : function(id, config)
		{
			try { return this.getEvents()[id] = config; } catch(e) { return []; }
		},
		"getThrottleRule": function(eventId)
		{
			try
			{
				return this.getEvents()[eventId].throttleRule;
			}
			catch(e)
			{
				logWarning("getThrottleRule: failed, cannot find throttle rule attached to " + eventId);
				return null;
			}
		},
		"_events": null
	}
	return event_config;
}

// register with the factory function with ModuleManager
ModuleManager.registerFactory("config_manager", CreateEventConfig);

//export {CreateEventConfig};
//globalEngine.FactoryMap["config_manager"] =  CreateEventConfig;
